import {
  selectCodiceTipoScommessaListFromSettings,
  selectCurrentScommesseType,
  selectFilteredCodiceTipoScommessa,
  selectIppicaInfoTipoScommessa,
  selectIsQf,
  selectPulsantieraGruppoScommessa,
  selectPulsantieraTipoScommessa,
} from 'features/ippica/selectors';
import { setBlockIppicaTypeScommessa, setScommesseType, setTipoScommessaKey } from 'features/ippica/ippicaSlice';
import { useEffect, useState } from 'react';

import { DynamicIppicaModalInfoScommessa } from '../../ippicaInfoScommessaModal/IppicaInfoScommessaModal';
import { IppicaScommesseFilterList } from '../../ippicaScommesseFilter/ippicaScommsseFilterList/IppicaScommesseFilterList';
import { IppicaScommesseType } from 'features/ippica/types';
import { IppicaScommesseTypeSwitch } from 'features/ippica/components/ippicaScommesseTypeSwitch';
import React from 'react';
import { ScommesseAccordionFilterPrimary } from 'components/scommesseAccordionFilterPrimary';
import { ScommesseAccordionFilterSecondary } from 'components/scommesseAccordionFilterSecondary';
import { ScommesseFiltersListScrollable } from 'components/scommesseFiltersListScrollable/ScommesseFiltersListScrollable';
import { ScommesseFiltersListWithInfo } from 'components/scommesseFiltersListWithInfo';
import { ScommesseTitle } from 'components/scommesseTitle';
import { isQuotaFissa } from 'features/ippica/functions';
import { selectIsOpenCarrello } from 'features/carrello/carrelloSelectors';
import styles from './IppicaTipiScommessaRendererFilters.module.scss';
import { useDispatch } from 'react-redux';
import { useGetLabelsByKeys } from 'hooks/useLingUI';
import { useRouter } from 'next/router';
import { useTypedSelector } from 'lib/centralStore';
import useWindowSize from 'hooks/useWindowSize';

export const IppicaTipiScommessaRendererFilters = () => {
  const route = useRouter().asPath;
  const dispatch = useDispatch();
  const [scommesseLabel, makeYourBetLabel, tipoScommessaLabel] = useGetLabelsByKeys([
    'scommesse',
    'make-your-bet',
    'scommessa-type',
  ]);
  // select index pulsantiera
  const [selectedIndex, setSelectedIndex] = useState<{ row: number; column: number }>({ row: 0, column: 0 });
  const [selectedSecondaryFilter, setSelectedSecondaryFilter] = useState<number>(0);

  const [scommesseTypeIndex, setScommesseTypeIndex] = useState<number>(0);

  // create pulsantiera
  const pulsantieraGruppoTipoScommessa = useTypedSelector(selectPulsantieraGruppoScommessa);

  const rowGruppoTipoScommessa = pulsantieraGruppoTipoScommessa?.[selectedIndex.row];
  const columnGruppoTipoScommessa = rowGruppoTipoScommessa?.items[selectedIndex.column];

  const titleFirstGroup = rowGruppoTipoScommessa?.title;
  const labelFirstGroup = columnGruppoTipoScommessa?.descrizione;
  const scommesseType = columnGruppoTipoScommessa?.type;

  dispatch(setScommesseType(scommesseType));
  const ippicaInfoTipoScommessa = useTypedSelector(selectIppicaInfoTipoScommessa);
  const pulsantieraTipoScommessa = useTypedSelector(selectPulsantieraTipoScommessa(columnGruppoTipoScommessa?.block));
  const isOpen = useTypedSelector(selectIsOpenCarrello);
  const isQf = useTypedSelector(selectIsQf);

  const { isMobile } = useWindowSize();

  const codiceTipoScommessaListFromSettings = useTypedSelector(selectCodiceTipoScommessaListFromSettings);
  const currentScommesseType = useTypedSelector(selectCurrentScommesseType);
  const filteredCodiceTipoScommessa = useTypedSelector(
    selectFilteredCodiceTipoScommessa(columnGruppoTipoScommessa?.block)
  );
  useEffect(() => {
    setSelectedIndex({ row: 0, column: 0 });
    setSelectedSecondaryFilter(0);
    dispatch(setTipoScommessaKey(undefined));
  }, [dispatch, route]);

  // appena atterro cosa succede
  useEffect(() => {
    if (isQf) {
      if (selectedIndex.row === 1) {
        // totalizzatore
        dispatch(setBlockIppicaTypeScommessa(String(rowGruppoTipoScommessa?.items[0].block)));
      } else {
        dispatch(setBlockIppicaTypeScommessa(''));
        // quota fissa
      }
    } else {
      dispatch(setBlockIppicaTypeScommessa(String(rowGruppoTipoScommessa?.items[0].block)));
    }
  }, [dispatch, isQf, rowGruppoTipoScommessa?.items, selectedIndex.row]);

  useEffect(() => {
    if (currentScommesseType && isQuotaFissa(currentScommesseType)) {
      dispatch(setBlockIppicaTypeScommessa(String(columnGruppoTipoScommessa?.block)));
      dispatch(setTipoScommessaKey(filteredCodiceTipoScommessa));
    }
  }, [
    codiceTipoScommessaListFromSettings,
    columnGruppoTipoScommessa,
    currentScommesseType,
    dispatch,
    filteredCodiceTipoScommessa,
  ]);

  useEffect(() => {
    if (!!pulsantieraTipoScommessa?.length && pulsantieraTipoScommessa[selectedSecondaryFilter]) {
      dispatch(setTipoScommessaKey(pulsantieraTipoScommessa[selectedSecondaryFilter].key));
    }
  }, [dispatch, selectedIndex, pulsantieraTipoScommessa, selectedSecondaryFilter]);

  useEffect(() => {
    setSelectedSecondaryFilter(0);
  }, [selectedIndex.column]);

  useEffect(() => {
    dispatch(setScommesseType(scommesseType));
  }, [dispatch, scommesseType]);

  if (isMobile) {
    return (
      <>
        <IppicaScommesseTypeSwitch
          selectedItem={scommesseTypeIndex}
          onSelectedElement={(index) => {
            setScommesseTypeIndex(index);
            setSelectedIndex({ row: index, column: 0 });
            setSelectedSecondaryFilter(0);
          }}
          listButton={pulsantieraGruppoTipoScommessa.map((element) => {
            return `${element.title}`;
          })}
        />

        <ScommesseFiltersListScrollable
          key={scommesseTypeIndex}
          selectedItem={0}
          color={'primary'}
          onSelectedElement={(index) => {
            setSelectedIndex({ row: scommesseTypeIndex, column: index });
            setSelectedSecondaryFilter(0);
          }}
          className={styles.gruppoMobileContainer}
          list={pulsantieraGruppoTipoScommessa[scommesseTypeIndex]?.items.map((tipiScommessa) => {
            return { label: `${tipiScommessa.descrizione}`, labelTrKey: '' };
          })}
        />
        {scommesseType !== IppicaScommesseType.QF && (
          <div className={styles.scommessseFilterWithInfoContainer}>
            <ScommesseFiltersListWithInfo
              onSelectedFilter={(selectedSecondaryFilterIndex: number) => {
                setSelectedSecondaryFilter(selectedSecondaryFilterIndex);
              }}
              selectedIndex={selectedSecondaryFilter}
              items={pulsantieraTipoScommessa}
              hasWhiteBackground
            />
          </div>
        )}
        {ippicaInfoTipoScommessa.isOpen && <DynamicIppicaModalInfoScommessa />}
      </>
    );
  }

  return (
    !!pulsantieraGruppoTipoScommessa?.length && (
      <div className={`${styles.container} ${!isOpen ? styles.hasMarginRight : ''}`}>
        <ScommesseTitle className={styles.text}>{makeYourBetLabel}</ScommesseTitle>

        <ScommesseAccordionFilterPrimary
          hasMarginBotton
          label={scommesseLabel}
          classNameContainer={`${styles.heightAuto} ${styles.noPaddingTop}`}
          selectedFilter={`${labelFirstGroup}/${titleFirstGroup}`}
          isEverythingVisible
        >
          <IppicaScommesseFilterList
            className={styles.titles}
            onSelectedFilter={({ row, column }: { row: number; column: number }) => {
              setSelectedIndex({ row, column });
            }}
            selectIndexItem={selectedIndex}
            gruppoList={pulsantieraGruppoTipoScommessa}
          />
        </ScommesseAccordionFilterPrimary>

        {scommesseType !== IppicaScommesseType.QF && !!pulsantieraTipoScommessa?.length && (
          <ScommesseAccordionFilterSecondary
            label={tipoScommessaLabel}
            selectedFilter={pulsantieraTipoScommessa[selectedSecondaryFilter]?.label}
            hasMarginBottom
            isAccordionClosed={true}
          >
            <ScommesseFiltersListWithInfo
              onSelectedFilter={(selectedSecondaryFilterIndex: number) => {
                setSelectedSecondaryFilter(selectedSecondaryFilterIndex);
              }}
              selectedIndex={selectedSecondaryFilter}
              items={pulsantieraTipoScommessa}
            ></ScommesseFiltersListWithInfo>
          </ScommesseAccordionFilterSecondary>
        )}
        {ippicaInfoTipoScommessa.isOpen && <DynamicIppicaModalInfoScommessa />}
      </div>
    )
  );
};
